"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/MembersTab/components/ToolBar/SearchBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _types = require('../../types');
var _keyboard = require('web/services/keyboard');








const SearchBar = ({
  searchQuery,
  setSearchQuery,
  pendingFilter,
  setPendingFilter,
}) => (
  _react2.default.createElement('div', { className: "settings--org-members--search-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
    ,  pendingFilter === _types.PendingFilter.PENDING && (
      _react2.default.createElement('div', { className: "settings--org-members--filter-pill", role: "note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}, "Pending"

        , _react2.default.createElement('div', {
          role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
          'aria-label': "Clear Pending filter"  ,
          className: "settings--org-members--filter-pill-icon",
          onClick: () => setPendingFilter(_types.PendingFilter.ALL), __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
        )
      )
    )
    , _react2.default.createElement('div', { className: "settings--org-members--search-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}} )
    , _react2.default.createElement('input', {
      value: searchQuery,
      onChange: e => setSearchQuery(e.target.value),
      placeholder: "Search for members"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
    )
  )
)

exports. default = SearchBar
